import React, { Component } from "react";
// import Header from './Header.js'
// import Footer from './Footer';
import ProjPeopleContent from "./ProjPeopleContent";

/**
 * Project Management Unit (DPD & PD)
 *  <ProjPeopleContent data>  -- Common Component
 */
const data = {
  header: ["S.No. ", "Role", "Officer", "Responsibility"],
  rows: {
    row1: [
      "1",
      "Project Director",
      "Shri. P.V. Raju, Group Director, WRG, RSAA",
      "Overall Project Co-ordination, Management & Execution, Budget Management & Interface with Ministry of Jal Shakti.",
    ],
    row2: [
      "2",
      "Nodal Officer & Deputy Project Director",
      "Shri. K. Abdul Hakeem, Head, WRID/WRG, RSAA",
      "Development of Web Enabled Hydrological Modeling in SWAT.Operational Hydrological Drought Services using Remote Sensing Data. Water Information Systems, Development & Dissemination.",
    ],
    row3: [
      "3",
      "Deputy Project Director",
      "Dr. K.H.V. Durga Rao, Group Head, DMSG, RSAA",
      "Real-time Operational Spatial Flood Early Warning System Development.",
    ],
    row4: [
      "4",
      "Deputy Project Director",
      "Dr. K. Chandrasekar, Head, WRP&DD/WRG, RSAA",
      " Development of Satellite-based Regional Evaporative Flux Monitoring System for India. Satellite data based inputs for Irrigation Scheduling for a selected Irrigation Project Command Area.",
    ],
    row5: [
      "5",
      "Deputy Project Director",
      "Shri B.Simhadri Rao, Head,WRAD/WRG, RSAA",
      "Glacial Lake Outburst Flood(GLOF) Risk Assessment. Development of Spatial Snowmelt Runoff Product in the Indian Himalayas. Operational National Hydrological Modeling System for the entire Country. Customized RS & GIS Training and Capacity Building.",
    ],
   
  },
};

const data1 = {
  header: ["S.No. ", "Role", "Officer", "Responsibility"],
  rows: {
    row1: [
      "1",
      "Project Director",
      "Dr. V. Venkateswar Rao, Associate Director, NRSC",
      "Overall Project Co-ordination, Management & Execution, Interface with MoWR, RD & GR",
    ],
    row2: [
      "2",
      "Deputy Project Director",
      "Shri. P.V. Raju, Group Director, WRG",
      "Snow & Glacial Studies, Hydrological  Modeling of River Basins of South and Eastern India, Budget Management",
    ],
    row3: [
      "3",
      "Deputy Project Director",
      "Shri. K. Abdul Hakeem, Head, WRID",
      "Water  informatics & Hydro-information Products (ET, Hydrologic Drought)",
    ],
    row4: [
      "4",
      "Deputy Project Director",
      "Dr. K.H.V. Durga Rao, Group Head, DMSG",
      "Flood Early Warning, Modeling Protocols and R & D activities",
    ],
    row5: [
      "5",
      "Deputy Project Director",
      "Dr. V.M. Chowdary, Group Director, ASAG",
      "Process based studies and Hydrological Modeling of River Basins of North and Western India",
    ],
    row6: [
      "6",
      "Deputy Project Director",
      "Shri.  M. Shanker, S/E  'SG', WRAD, WRG (till 25-July-2018)",
      "Capacity Building & Irrigation Water Management",
    ],
  },
};
export default class ProjectManagement extends Component {
  render() {
    return (
      <div>
        <div
          style={{ padding: "15px"}}
          className="card"
        >
          <h3 style={{ textAlign: "center", color: "#002120" }}>
            Project Management Team
          </h3>
          </div>
          {/* <h5 style={{textAlign:"right",color: "#002171",margin:"0px",padding:"0px"}}> *Note: Red color denotes Ex-Employees</h5> */}
          <div className="card-body" style={{width:"70vw",margin:"0 auto"}} >
            <ProjPeopleContent data={data} /></div>


            <div
          style={{ padding: "15px" }}
          className="card"
        >
          <h3 style={{ textAlign: "center", color: "#002120"}}>
            Project Management Team (09-Feb-2018 to 07-May-2023)
          </h3>
            </div>
            
            <div className="card-body" style={{width:"70vw",margin:"0 auto"}} >

            <ProjPeopleContent data={data1} />
            </div>

        
        
      </div>
    );
  }
}
